import { useState, useEffect } from "react";
import { Table } from "antd";
import { GlobalFilter } from "../components/table/FilteringTable/GlobalFilter";
import { sortList } from "./Users";
import formatError from "../../services/FormatError";
import AddContractTypes from "./AddContractTypes";
import {
  deleteContractType,
  fetchAllContractTypes,
} from "../../services/ContractTypes";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";


function ContractTypes() {
    const { t } = useTranslation();

  const role = JSON.parse(sessionStorage.getItem("userDetails"))?.result;

  const [ctData, setCTData] = useState({
    original: [],
    filtered: [],
  });

  const [gridFilter, updateGridFilter] = useState("");

  const [addCT, setAddCT] = useState({
    cond: false,
    id: null,
  });

  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    if (role?.role?.id === 1 || role?.role?.id === 2) {
      fetchContractTypes();
    }
  }, []);

  const fetchContractTypes = () => {
    fetchAllContractTypes()
      .then((res) => {
        let response = res.data?.result ?? [];

        response = sortList(response);

        setCTData({
          original: [...response],
          filtered: [...response],
        });

        setTableParams((prevTableParams) => ({
          ...prevTableParams,
          total: [...response]?.length,
        }));
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const updateGridData = (value) => {
    updateGridFilter(value);

    if (value !== "") {
      const filteredData = ctData.original.filter((item) =>
        item?.name.toLowerCase().includes(value.toLowerCase())
      );

      setCTData((prevState) => ({
        ...prevState,
        filtered: filteredData,
      }));
    } else {
      setCTData((prevState) => ({
        ...prevState,
        filtered: [...prevState.original],
      }));
    }
  };

  const onAddContractTypes = () => {
    setAddCT({
      cond: true,
      id: null,
    });
  };

  const onUpdateCT = (id) => {
    setAddCT({
      cond: true,
      id: id,
    });
  };

  const onDeleteCT = (id) => {
     swal({
      title: t("hdelete"),
      text: t("hconfirmationDelete"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willdelete) => {
      if(willdelete){
        deleteContractType(id)
          .then((res) => {
            swal(t("hsuppressionsuccess"),{icon: "success"});
            fetchContractTypes();
          })
          .catch((error) => {
            formatError(error.response?.data?.error);
          })
      }
    })
  };

  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };

  const columns = [
    {
      title: "S.NO",
      dataIndex: "id",
      sorter: true,
      width: "5%",
      render: (data, obj, index) =>
        tableParams.current
          ? index + 1 + (tableParams.current - 1) * tableParams.pageSize
          : index + 1,
    },
    {
      title: t("sidebarItemContractTypes"),
      dataIndex: "name",
      sorter: true,
      width: "20%",
    },
    {
      title: `${t("buyerProfileCulumn7")}`,
      dataIndex: "actions",
      render: (text, record) => {
        return (
          <div class="d-flex action-button">
            <a
              href="javascript:void(0);"
              class="btn btn-info btn-xs light px-2"
              onClick={() => onUpdateCT(record?.id)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
                  stroke="#fff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </a>
            <a
              href="javascript:void(0);"
              class="ms-2 btn btn-xs px-2 light btn-danger"
              style={{ marginRight: "8px" }}
              onClick={() => onDeleteCT(record?.id)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 6H5H21"
                  stroke="#fff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                  stroke="#fff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </a>
          </div>
        );
      },
      width: "20%",
    },
  ];

  return (
    <>
      <div className="row">
        <div style={{ marginBottom: "1rem" }} className="card col-lg-12">
          <div className="card-header d-sm-flex d-block">
            <div className="d-flex me-auto mb-sm-0">
              <h4 className="card-title">{t("sidebarItemContractTypes")}</h4>
            </div>
            <GlobalFilter filter={gridFilter} setFilter={updateGridData} />
            <div style={{ paddingLeft: "12px" }}>
              <a
                href="javascript:void(0);"
                class="btn btn-info"
                onClick={onAddContractTypes}
              >
                + {t("haddContractType")}
              </a>
            </div>
          </div>

          <div class="card-body">
            <Table
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={ctData.filtered}
              pagination={tableParams}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </div>

      {addCT?.cond && (
        <AddContractTypes
          show={addCT?.cond}
          id={addCT?.id}
          fetchContractTypes={fetchContractTypes}
          onHide={() =>
            setAddCT({
              cond: false,
              id: null,
            })
          }
        />
      )}
    </>
  );
}

export default ContractTypes;
